<div class="mt-8">
  <ui-search
    [placeholder]="'SIDEBAR.SEARCH_ORGANIZATION_PLACEHOLDER'|translate"
    [heightPx]="40"
    (onInput)="onSearchInput($event)"
  ></ui-search>
</div>
@if (isSearching$ | async) {
  <div class="loader-container flex-row center-center">
    <ui-preloader [color]="loaderColor.blue"></ui-preloader>
  </div>
} @else {
  <div class="flex-col h-100 organization-list-wrapper">
    <div class="flex-row start-center organization-item list gap-8"
         *ngFor="let organization of (organizations$ | async)"
         (click)="openSupportAccessModal(organization)"
    >
      <ui-avatar class="org-avatar selectable"
                 [name]="organization.name"
                 [color]="organization.color"
                 [fontSize]="10"
      ></ui-avatar>
      <ui-truncated-html class="truncated-name">
        {{ organization.name }}
      </ui-truncated-html>
    </div>
  </div>
}
